import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Inbox = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M21.948 11.684l-2.771-8.315A1.998 1.998 0 0 0 17.279 2H6.721c-.863 0-1.625.55-1.897 1.367l-2.772 8.316.012.004A.939.939 0 0 0 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6a.964.964 0 0 0-.063-.313l.011-.003zM16 11h-.142c-.446 1.722-1.997 3-3.858 3s-3.412-1.278-3.858-3H4.387l2.334-7H17.28l2.334 7H16z", key: "k0" })));
});
Inbox.displayName = 'Inbox';
export var InboxDimensions = { height: 24, width: 24 };
